import HamburgerMenu from '../helpers/HamburgerMenuAnimated';
import { SELECTORS } from '../config/constants';

export default function () {
  const toggleEl = document.querySelector(SELECTORS.HAMBURGER);

  if (!toggleEl) {
    return;
  }

  return new HamburgerMenu(toggleEl).init();
}
